import { useState } from "react"

import { Collapse, Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { NavLink } from "react-router-dom"

import Icon from "../../../../Icon"

const { Title, Text } = Typography

const faqData = [
  {
    title: "How do I refer someone?",
    text: "You can refer someone using your unique referral link or by sending them an email. Both options are available at the top of this page."
  },
  {
    title: "What is my commission?",
    text: "You earn $2 for each Ethoca Alert and $1 for each Verifi Alert (RDR and CDRN). You'll also receive bonus cash rewards when your referrals hit certain Alert milestones. See details at the top of this page."
  },
  {
    title: "When and how do I get paid?",
    text: " Your commissions will be added to your rewards in real-time for any paid Alerts and can be withdrawn via bank transfer or Chargeback credits. Your account manager will reach out to arrange the details."
  },
  {
    title: "How do I track my referrals and earnings?",
    text: (
      <div>
        You can track all your referrals and earnings from the{" "}
        <NavLink to="?id=Earnings">Earnings</NavLink> tab. Your personal dashboard also shows how
        many Alerts each referred business has received, from which Alert provider they came from,
        and more.
      </div>
    )
  },
  {
    title: "Is there a limit to how many people I can refer?",
    text: "No, there's no limit. You can refer as many businesses as you like and keep earning from each one."
  },
  {
    title: "What counts as a successful referral?",
    text: "A referral is considered successful once the user signs up, enrolls with an Alert provider (Ethoca or Verifi), and begins receiving Alerts. That's also when your earnings start."
  },
  {
    title: "Do I still earn if the person I referred refers someone else?",
    text: "You only earn from the businesses you refer directly. If someone you referred later joins the referral program, they'll earn from their own referrals moving forward. This ensures everyone is fairly rewarded for their direct contributions."
  },
  {
    title: "Are there any restrictions or conditions?",
    text: "Yes, there are a few conditions. Self-referrals are not allowed, and all referred businesses must be new to Chargeback . Fraudulent activity or abuse of the program may lead to disqualification and forfeited commissions."
  },
  {
    title: "Do referrals expire?",
    text: "No, referrals never expire. Since commissions are earned per Alert, your earnings continue for life — as long as your referred businesses stay active, you keep getting paid."
  },
  {
    title: "Is this your best offer?",
    text: "Yes, this is the best offer in the industry. Our referral program gives you some of the highest commissions for Ethoca and Verifi. On top of that, we offer exclusive milestone bonuses totaling up to $25,000 USD that no other program provides. There are no better opportunities out there."
  }
]

const Faq = () => {
  const { t } = useTranslation()
  const faq = useSelector((state) => state.referrals?.faq)

  return (
    <div className="referral-faq-block">
      <Title level={4}>{"Frequently asked questions"}</Title>
      <Text type="secondary">
        {t("Answers to common questions. For anything else, kindly contact your account manager.")}
      </Text>
      <div style={{ paddingTop: "32px" }}>
        <Flex vertical>
          {faqData.map((item, id) => {
            const [activeKey, setActiveKey] = useState(null)

            const togglePanel = (e) => {
              if (["BUTTON", "A", "INPUT", "TEXTAREA"].includes(e.target.tagName)) return
              setActiveKey((prev) => (prev === id ? null : id))
            }

            return (
              <div
                onClick={togglePanel}
                key={id}
                className="faq-item-container"
                style={{
                  marginTop: activeKey === id ? "14px" : "0"
                }}
              >
                <Collapse
                  ghost
                  expandIconPosition="end"
                  accordion
                  activeKey={activeKey}
                  expandIcon={({ isActive }) => (
                    <Icon
                      type="chevron_down"
                      style={{
                        transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease"
                      }}
                    />
                  )}
                  items={[
                    {
                      key: id,
                      label: <Text className="faq-title">{item.title}</Text>,
                      className: "faq",
                      classNames: { header: "faq", body: "faq" },
                      children: <div>{item.text}</div>
                    }
                  ]}
                />
              </div>
            )
          })}
        </Flex>
      </div>
    </div>
  )
}

export default Faq
